// start:ng42.barrel
export * from './page-section.model';
// end:ng42.barrel




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/common/model/page/index.ts